module.exports = __webpack_public_path__ + "static/media/redeemInfo22040601.7779a8f0.jpg";